/* eslint-disable react/no-unstable-nested-components */
import { DatePicker } from '@mantine/dates';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { notifications } from '@mantine/notifications';
import { ReactComponent as IconError } from "src/assets/icons/toast-error.svg";
import { ReactComponent as IconSuccess } from "src/assets/icons/toast-success.svg";
import { ReactComponent as ChevronIcon } from "src/assets/icons/chevron-left.svg";
import { ScreenLoader } from "src/components/screenLoader";
import { Button as MantineButton } from '@mantine/core';
import { NextButton, ScreenWrapper } from '../../components';
import { OnboardingProgress } from '../../components/onboardingProgress';
import { RootState } from '../../redux/store';
import { useCommonStyles } from '../../styles/commonStyles';
import { useStyles } from './changeDob.styles';
import { clearPanDetailsFormError, setPanDetailsFormStatus, verifyPanNumber } from './panDetailsFormSlice';

export const ChangeDob = () => {
  const { classes, cx } = useStyles();
  const { commonClasses } = useCommonStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accountState = useSelector((state: RootState) => state.account);
  const { userDetails } = accountState
  const [dob, setDob] = useState(userDetails?.dateOfBirth || '01/01/2000');
  const isButtonDisabled = false;
  const panDetailsState = useSelector((state: RootState) => state.panDetails);

  const onNextClick = () => {
    dispatch(verifyPanNumber({ pan: panDetailsState.panNumber, dateOfBirth: dob }));
  };

  const getVal = (val: string) => {
    const dateArr = val.split('/');
    const d = `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`;
    return d;
  };

  useEffect(() => {
    if (panDetailsState.status === 'success') {
      dispatch(setPanDetailsFormStatus('idle'));
      notifications.show({
        color: 'green',
        message: 'PAN card Verified Successfully!',
        icon: <IconSuccess />,
      });
      const nextStepFromBackend = userDetails.nextStep === "/aadhaar-verification"
        ? "kyc-verification"
        : userDetails.nextStep;
      const nextStep = `/${nextStepFromBackend.replace("_", "-")}`;
      navigate(nextStep);
    } else if (panDetailsState.status === 'error') {
      dispatch(clearPanDetailsFormError());
      notifications.show({
        color: 'red',
        message: panDetailsState.error.message || 'PAN card verification failed!',
        icon: <IconError />,
      });
    }
  }, [panDetailsState.status]);

  const onDateChange = (DOB: any) => {
    if (DOB) {
      setDob(dayjs(DOB).format('DD/MM/YYYY'));
    }
  };

  const handleClearPanNumber = () => {
    navigate("/verify-pan");
  }

  return (
    <ScreenWrapper>
      <div className="csMainContainer">
        <div className="csHeader">
          <div className="csProgressWrapper">
            <OnboardingProgress progress={30} />
          </div>
        </div>
        <div className={classes.contentContainer}>
          <h2 className="csHeading">Date of birth</h2>
          <p className="csDescription">Enter your date of birth to continue</p>
          <div className={classes.dateInputWrapper}>
            <DatePicker
              maxDate={new Date()}
              minDate={new Date("01/01/1900")}
              value={new Date(getVal(dob))}
              onChange={onDateChange}
              defaultDate={
                new Date(
                  dob.split("/")[2],
                  parseInt(dob.split("/")[1], 10) - 1,
                  dob.split("/")[0]
                )
              }
            />
          </div>
        </div>
        <div className={cx(commonClasses.footer, classes.footer)}>
          <div className={classes.footerActionContainer}>
            <MantineButton
              onClick={handleClearPanNumber}
              radius={8}
              variant="subtle"
              leftIcon={<ChevronIcon />}
            >
              Back
            </MantineButton>
            <NextButton disabled={isButtonDisabled} onClick={onNextClick}>
              Next
            </NextButton>
          </div>
        </div>
      </div>
      {panDetailsState.status === "loading" ? <ScreenLoader /> : null}
    </ScreenWrapper>
  );
};

export default ChangeDob;
